import React from 'react'

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 3.21852L14.4657 10L16 8.39074L8 0L0 8.39074L1.53432 10L8 3.21852Z" fill="currentColor"/>
  </svg>

)
